export default "__VITE_PUBLIC_ASSET__cea3cb61__"